import {createFileRoute} from '@tanstack/react-router';
import {NotificationsPage} from '../../../../features/settings/pages/NotificationsPage';

export const Route = createFileRoute('/_protected/home/service/notifications')({
  component: NotificationsPage,
  staticData: {crumbKey: 'navigation.notifications'},
});
